module.exports = __webpack_public_path__ + "img/search-header-nav-below-infiniti.db6434ec.png";